import Link from "next/link";
import { HiArrowRight } from "@onemind-services-llc/react-icons-ng/hi";
import { Button } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";
import Intro_Img from "public/customer-testimonials/Intro_Img.png";

export const INTRO_CONSTANTS = {
  heading: "Success Story",
  title: "Revitalizing a Credit Union: Strengthening Security and Scaling for Growth.",
  description:
    "A credit union facing outdated technology and security risks partnered with OneMind Services to regain control, modernize its infrastructure, and migrate to a secure cloud environment. Through phased improvements — reclaiming access, upgrading systems, and future-proofing operations — the organization achieved a scalable, secure, and resilient setup for long-term growth.",
  children: (
    <>
      <Link
        href="/case-studies/revitalizing-a-Credit-Union"
        style={{ fontWeight: 500, color: "#021B66", marginTop: "-0.75rem" }}
      >
        ...Read Full Story
      </Link>
      <Button
        variant={"ideal"}
        rightIcon={<HiArrowRight />}
        mt={4}
        onClick={() => scrollToElement("stories", 120)}
        width="fit-content"
      >
        Explore More Stories
      </Button>
    </>
  ),
  image: Intro_Img,
};
